export default __webpack_public_path__ + "static/cyber-01a6abdfb050ab0406c44102dca9af8c.png";